function getSmallerImgUrl(imgUrl: string, size = 100, quality = 50) {// size需要保持100，不然alicdn不支持
  if (imgUrl && imgUrl.startsWith('https://cms-service.oss-accelerate.aliyuncs.com')){
    imgUrl = imgUrl.replace("https://cms-service.oss-accelerate.aliyuncs.com", "https://cdn.cms.opsloth.com")
  }
  if (imgUrl && (imgUrl.startsWith('https://cms-service.oss-cn-shanghai.aliyuncs.com')
    || imgUrl.startsWith('http://cms-service.oss-cn-shanghai.aliyuncs.com')
    || imgUrl.startsWith('https://cdn.cms.opsloth.com')
    || imgUrl.startsWith('http://cdn.cms.opsloth.com')
    || imgUrl.startsWith('https://cms-service.oss-accelerate.aliyuncs.com'))) {
    return imgUrl + `?x-oss-process=image/resize,w_${size}/quality,q_${quality}/format,webp`
  } else if (imgUrl && imgUrl.indexOf('alicdn.com') >= 0) {
    return imgUrl + `_${size}x${size}_.webp`
  } else {
    return imgUrl
  }
}
export default getSmallerImgUrl